export const ADHOC_USER_PATH = ["/guest-login", "/guest-form-submission"];
